export const normalizeGenderSpecific = (value) => {
    const normalizedValue = String(value || "").trim().toLowerCase();

    if (normalizedValue === "male" || normalizedValue === "m") {
        return "Male";
    }

    if (normalizedValue === "female" || normalizedValue === "f") {
        return "Female";
    }

    return null;
};
